var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_541_4411)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8677 7.75686C15.0566 8.60282 16.4804 9.0548 17.9392 9.04932V6.15575C17.6524 6.15654 17.3664 6.12581 17.0863 6.06412V8.36933C15.6243 8.37193 14.1984 7.91476 13.01 7.0624V13.0135C13.0064 13.99 12.7388 14.9474 12.2357 15.784C11.7325 16.6207 11.0125 17.3055 10.1521 17.7658C9.29158 18.2261 8.32268 18.4447 7.34811 18.3985C6.37354 18.3523 5.42962 18.043 4.61646 17.5034C5.36862 18.2651 6.32969 18.7863 7.37799 19.0009C8.42628 19.2156 9.51464 19.114 10.5052 18.7092C11.4958 18.3043 12.3441 17.6143 12.9427 16.7266C13.5413 15.8389 13.8632 14.7934 13.8677 13.7224V7.75686ZM14.9229 4.80541C14.3183 4.14949 13.9473 3.31191 13.8677 2.42304V2.04688H13.0582C13.1582 2.61188 13.376 3.14949 13.6972 3.62475C14.0185 4.10001 14.4361 4.50228 14.9229 4.80541ZM6.49079 15.2126C6.21022 14.8454 6.03829 14.4068 5.99455 13.9466C5.95081 13.4864 6.03702 13.0231 6.24337 12.6095C6.44972 12.196 6.76793 11.8487 7.16177 11.6072C7.55561 11.3657 8.00927 11.2397 8.47112 11.2436C8.72611 11.2435 8.97961 11.2826 9.22279 11.3594V8.36933C8.93852 8.33165 8.65181 8.31553 8.36512 8.32111V10.6456C7.77301 10.4583 7.13213 10.5009 6.56997 10.7649C6.0078 11.029 5.56554 11.4952 5.33114 12.0707C5.09675 12.6463 5.0874 13.2891 5.30494 13.8713C5.52249 14.4534 5.951 14.9323 6.50524 15.2126H6.49079Z",
    fill: "#EE1D52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0097 7.04311C14.1981 7.89547 15.624 8.35263 17.086 8.35004V6.04483C16.253 5.86855 15.4963 5.43504 14.9226 4.80541C14.4358 4.50228 14.0182 4.10001 13.6969 3.62475C13.3757 3.14949 13.1579 2.61188 13.0579 2.04688H10.9282V13.7224C10.9262 14.2392 10.7625 14.7424 10.4602 15.1614C10.1579 15.5804 9.73213 15.8941 9.24261 16.0585C8.75308 16.2228 8.22441 16.2297 7.73081 16.078C7.23721 15.9263 6.80347 15.6237 6.49047 15.2126C5.99444 14.9621 5.59719 14.5517 5.36283 14.0475C5.12846 13.5433 5.07064 12.9747 5.1987 12.4336C5.32676 11.8925 5.63323 11.4103 6.06866 11.0649C6.5041 10.7195 7.04309 10.531 7.59869 10.5299C7.85361 10.5307 8.10697 10.5697 8.35035 10.6456V8.3211C7.29879 8.34637 6.27749 8.67839 5.4118 9.27642C4.54612 9.87445 3.87373 10.7125 3.47717 11.6876C3.08062 12.6627 2.97715 13.7325 3.17948 14.7656C3.38181 15.7987 3.88113 16.7503 4.61614 17.5034C5.42948 18.0469 6.37488 18.3594 7.35164 18.4076C8.3284 18.4558 9.29994 18.238 10.1628 17.7772C11.0256 17.3165 11.7474 16.6301 12.2513 15.7912C12.7552 14.9523 13.0223 13.9923 13.0241 13.0135L13.0097 7.04311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0863 6.04471V5.42259C16.3213 5.42584 15.5711 5.21179 14.9228 4.80529C15.4951 5.43673 16.2524 5.8706 17.0863 6.04471ZM13.0581 2.04676C13.0581 1.93584 13.0244 1.82009 13.0099 1.70917V1.33301H10.0708V13.0134C10.0682 13.6674 9.8065 14.2937 9.34308 14.7548C8.87967 15.216 8.2524 15.4742 7.59894 15.4729C7.21418 15.4749 6.83443 15.3856 6.49073 15.2125C6.80372 15.6235 7.23747 15.9261 7.73106 16.0778C8.22466 16.2295 8.75333 16.2227 9.24286 16.0583C9.73239 15.894 10.1582 15.5803 10.4605 15.1613C10.7628 14.7423 10.9264 14.2391 10.9284 13.7223V2.04676H13.0581ZM8.35061 8.31616V7.65546C7.14115 7.49102 5.9117 7.74142 4.86263 8.36586C3.81357 8.99031 3.00674 9.95197 2.57364 11.0941C2.14054 12.2363 2.10671 13.4916 2.47767 14.6555C2.84862 15.8193 3.60248 16.8231 4.61639 17.5033C3.88695 16.7484 3.39295 15.7972 3.19475 14.766C2.99655 13.7347 3.10273 12.668 3.50032 11.6962C3.89791 10.7243 4.5697 9.88944 5.43361 9.29347C6.29752 8.69751 7.31615 8.36629 8.36506 8.34028L8.35061 8.31616Z",
    fill: "#69C9D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_541_4411",
    x: 0,
    y: 0,
    width: 20,
    height: 20.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_541_4411"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktokIcon.89948aff64353707428b2e3a2831e11c.svg";
export { ForwardRef as ReactComponent };